import { useTranslation } from 'react-i18next';
import { FileText, Hash } from 'lucide-react';
import { useStoreQuery } from '../db/context';
import { useUi } from '../state/ui';

export function TagView({ tag }: { tag: string }) {
  const { t, i18n } = useTranslation();
  const open = useUi((s) => s.open);
  const pages = useStoreQuery((s) => s.pagesWithTag(tag), [tag], ['index', 'pages']);
  const tags = useStoreQuery((s) => s.listTags(), [], ['index']);
  const nested = tags?.filter((x) => x.tag.startsWith(`${tag.toLowerCase()}/`)) ?? [];
  const fmt = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium' });

  return (
    <section className="mx-auto w-full max-w-6xl px-6 py-6 sm:px-10">
      <h1 className="flex items-center gap-2 text-3xl font-bold">
        <Hash className="size-7 text-fg-muted" />
        {tag}
      </h1>
      {nested.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {nested.map((n) => (
            <button
              key={n.tag}
              type="button"
              onClick={() => open({ kind: 'tag', tag: n.tag })}
              className="nx-tag"
            >
              #{n.tag} <span className="text-fg-muted">{n.count}</span>
            </button>
          ))}
        </div>
      )}
      {pages && pages.length === 0 ? (
        <p className="mt-6 text-fg-muted">{t('tags.none')}</p>
      ) : (
        <ul className="mt-6 divide-y divide-border rounded-xl border border-border">
          {pages?.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                onClick={(e) => open({ kind: 'page', pageId: p.id }, e.ctrlKey || e.metaKey)}
                className="flex w-full items-center gap-3 px-3 py-2 text-left hover:bg-bg-hover"
              >
                <FileText className="size-4 text-fg-muted" />
                <span className="flex-1 truncate">{p.title || t('page.untitled')}</span>
                <span className="text-xs text-fg-muted">{fmt.format(p.updatedAt)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
